/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ScrollTabDecorator", function (context, cls) {
  /**
   * Add scroll tab mechanism to widget elements
   * @class ScrollTabDecorator
   * @memberOf classes
   */
  cls.ScrollTabDecorator = context.oo.Class(function ($super) {
    return /** @lends classes.ScrollTabDecorator.prototype */ {
      __name: "ScrollTabDecorator",

      _tabsHost: null,
      _tabsTitlesBar: null,
      _tabsTitlesHost: null,
      _tabsTitlesElement: null,
      /** @type {HTMLElement} */
      _previousScroller: null,
      /** @type {HTMLElement} */
      _nextScroller: null,
      _leftScrollInterval: null,
      _rightScrollInterval: null,
      _offsetPos: "offsetLeft",
      _offsetSize: "offsetWidth",
      _scrollPos: "scrollLeft",
      _scrollStep: 6,
      _scrollToId: 0,
      _refreshScrollersId: 0,

      _position: "top",
      _scrollerPosition: 0,

      _scrollSpeed: 10,
      _scrollClickOnly: false,
      _mouseDownStatus: false,

      /**
       * Initializes the scrollTab object. You need to provide a widget instance which will be instrumented
       * @param widget the widget to handle
       */
      constructor: function (widget) {
        $super.constructor.call(this);
        this._widget = widget;

        if (cls.WindowHelper.isMobile()) {
          this._widget.addClasses("compact");
        }

        this._tabsHost = this._widget.getElement().getElementsByClassName("mt-tabs")[0];
        this._tabsTitlesBar = this._widget.getElement().getElementsByClassName("mt-tab-titles-bar")[0];
        this._tabsTitlesHost = this._widget.getElement().getElementsByClassName("mt-tab-titles")[0];
        this._tabsTitlesElement = this._widget.getElement().getElementsByClassName("mt-tab-titles-container")[0];
        this._previousScroller = this._widget.getElement().getElementsByClassName("mt-tab-previous")[0];
        this._nextScroller = this._widget.getElement().getElementsByClassName("mt-tab-next")[0];

        cls.DOMElementHelper.on(
          this._widget.getElement(),
          "mouseover.FolderWidget",
          function () {
            this.refreshScrollers();
            cls.DOMElementHelper.off(this._widget.getElement(), "mouseover.FolderWidget");
          }.bind(this)
        );

        cls.DOMElementHelper.on(this._previousScroller, "mouseover.FolderWidget", this._beginScrollTabsLeft.bind(this));
        cls.DOMElementHelper.on(this._previousScroller, "mousedown.FolderWidget", this._beginScrollTabsLeft.bind(this));
        cls.DOMElementHelper.on(this._previousScroller, "mouseout.FolderWidget", this._endScrollTabsLeft.bind(this));
        cls.DOMElementHelper.on(this._previousScroller, "mouseup.FolderWidget", this._endScrollTabsLeft.bind(this));

        cls.DOMElementHelper.on(this._nextScroller, "mouseover.FolderWidget", this._beginScrollTabsRight.bind(this));
        cls.DOMElementHelper.on(this._nextScroller, "mousedown.FolderWidget", this._beginScrollTabsRight.bind(this));
        cls.DOMElementHelper.on(this._nextScroller, "mouseup.FolderWidget", this._endScrollTabsRight.bind(this));
        cls.DOMElementHelper.on(this._nextScroller, "mouseout.FolderWidget", this._endScrollTabsRight.bind(this));

        if (cls.WindowHelper.isTouchDevice()) {
          if (this._tabsTitlesBar) {
            cls.DOMElementHelper.on(this._tabsTitlesBar, "touchstart.scrolltab", this._startTouchScroll.bind(this));
            cls.DOMElementHelper.on(this._tabsTitlesBar, "touchend.scrolltab", this._endTouchScroll.bind(this));
            cls.DOMElementHelper.on(this._tabsTitlesBar, "touchmove.scrolltab", this._touchMove.bind(this));
          } else if (this._tabsTitlesElement) {
            cls.DOMElementHelper.on(this._tabsTitlesElement, "touchstart.scrolltab", this._startTouchScroll.bind(this));
            cls.DOMElementHelper.on(this._tabsTitlesElement, "touchend.scrolltab", this._endTouchScroll.bind(this));
            cls.DOMElementHelper.on(this._tabsTitlesElement, "touchmove.scrolltab", this._touchMove.bind(this));
          }
        }
        this._scrollSpeed = Number.parseInt(context.ThemeService.getValue("gbc-scrollers-speed"), 10);
        this._scrollClickOnly = context.ThemeService.getValue("gbc-scrollers-clickonly");
        this._scrollClickOnly = this._scrollClickOnly === true || this._scrollClickOnly === "true";
      },

      /**
       * @inheritDoc
       */
      destroy: function () {
        cls.DOMElementHelper.off(this._widget.getElement(), "mouseover.FolderWidget");

        cls.DOMElementHelper.off(this._previousScroller, "mouseover.FolderWidget");
        cls.DOMElementHelper.off(this._previousScroller, "mousedown.FolderWidget");
        cls.DOMElementHelper.off(this._previousScroller, "mouseout.FolderWidget");
        cls.DOMElementHelper.off(this._previousScroller, "mouseup.FolderWidget");
        cls.DOMElementHelper.off(this._nextScroller, "mouseover.FolderWidget");
        cls.DOMElementHelper.off(this._nextScroller, "mousedown.FolderWidget");
        cls.DOMElementHelper.off(this._nextScroller, "mouseup.FolderWidget");
        cls.DOMElementHelper.off(this._nextScroller, "mouseout.FolderWidget");

        if (this._scrollToId) {
          window.cancelAnimationFrame(this._scrollToId);
          this._scrollToId = 0;
        }
        if (this._refreshScrollersId) {
          window.cancelAnimationFrame(this._refreshScrollersId);
          this._refreshScrollersId = 0;
        }

        this._endScrollTabsLeft();
        this._endScrollTabsRight();

        if (cls.WindowHelper.isTouchDevice()) {
          if (this._tabsTitlesBar) {
            cls.DOMElementHelper.off(this._tabsTitlesBar, "touchstart.scrolltab");
            cls.DOMElementHelper.off(this._tabsTitlesBar, "touchend.scrolltab");
            cls.DOMElementHelper.off(this._tabsTitlesBar, "touchmove.scrolltab");
          }
          if (this._tabsTitlesElement) {
            cls.DOMElementHelper.off(this._tabsTitlesElement, "touchstart.scrolltab");
            cls.DOMElementHelper.off(this._tabsTitlesElement, "touchend.scrolltab");
            cls.DOMElementHelper.off(this._tabsTitlesElement, "touchmove.scrolltab");
          }
        }
        this._tabsHost = null;
        this._tabsTitlesBar = null;
        this._tabsTitlesHost = null;
        this._tabsTitlesElement = null;
        this._previousScroller = null;
        this._nextScroller = null;
        this._widget = null;
      },

      /**
       * Method to scroll titles to the Left
       * @param event
       * @private
       */
      _beginScrollTabsLeft: function (event) {
        // If click only, quit if event is not a click
        if (this._scrollClickOnly && event.type !== "mousedown") {
          cls.EventHelper.preventCancelableDefault(event);
          event.stopImmediatePropagation();
          event.stopPropagation();
          return;
        }

        // Do the actual scrolling to the left
        const scrollLeft = function (st) {
          let scroll = st._tabsTitlesHost[st._scrollPos];
          if (scroll > 0) {
            st._tabsTitlesHost[st._scrollPos] = scroll = scroll - st._scrollStep;
          }
          if (scroll <= 0) {
            st._previousScroller.classList.remove("overflown-previous");
            st._endScrollTabsLeft();
          } else {
            st._previousScroller.classList.add("overflown-previous");
          }
          cls.DOMElementHelper.toggleClass(
            st._nextScroller,
            "overflown-next",
            scroll + st._tabsTitlesHost[st._offsetSize] < st._tabsTitlesElement[st._offsetSize]
          );
        };

        scrollLeft(this);

        // If we keep mouse over the scroller (or clicked), continue scrolling according to the speed
        if (!this._leftScrollInterval) {
          this._leftScrollInterval = window.setInterval(
            function () {
              scrollLeft(this);
            }.bind(this),
            this._scrollSpeed
          );
        }
      },

      /**
       * Clear the scrolling to the left
       * @private
       */
      _endScrollTabsLeft: function () {
        if (this._leftScrollInterval) {
          window.clearInterval(this._leftScrollInterval);
          this._leftScrollInterval = null;
        }
      },

      /**
       * Method to scroll titles to the Right
       * @param event
       * @private
       */
      _beginScrollTabsRight: function (event) {
        if (this._scrollClickOnly && event.type !== "mousedown") {
          cls.EventHelper.preventCancelableDefault(event);
          event.stopImmediatePropagation();
          event.stopPropagation();
          return;
        }

        // Do the actual scrolling to the right
        const scrollRight = function (st) {
          const scroll = st._tabsTitlesHost[st._scrollPos];
          let now;
          st._tabsTitlesHost[st._scrollPos] = scroll + st._scrollStep;
          if ((now = st._tabsTitlesHost[st._scrollPos]) <= scroll) {
            st._nextScroller.classList.remove("overflown-next");
            st._endScrollTabsRight();
          } else {
            st._nextScroller.classList.add("overflown-next");
          }
          cls.DOMElementHelper.toggleClasses(st._previousScroller, now > 0, "overflown-previous");
        };

        scrollRight(this);

        // If we keep mouse over the scroller (or clicked), continue scrolling according to the speed
        if (!this._rightScrollInterval) {
          this._rightScrollInterval = window.setInterval(
            function () {
              scrollRight(this);
            }.bind(this),
            this._scrollSpeed
          );
        }
      },

      /**
       * Clear the scrolling to the right
       * @private
       */
      _endScrollTabsRight: function () {
        if (this._rightScrollInterval) {
          window.clearInterval(this._rightScrollInterval);
          this._rightScrollInterval = null;
        }
      },

      /**
       * Ensure the display state of the scrolling arrows
       */
      refreshScrollers: function () {
        if (this._refreshScrollersId) {
          window.cancelAnimationFrame(this._refreshScrollersId);
        }
        this._refreshScrollersId = window.requestAnimationFrame(
          function () {
            this._refreshScrollersId = 0;
            if (this._tabsTitlesHost) {
              const scroll = this._tabsTitlesHost[this._scrollPos];
              cls.DOMElementHelper.toggleClass(
                this._nextScroller,
                "overflown-next",
                scroll + this._tabsTitlesHost[this._offsetSize] < this._tabsTitlesElement[this._offsetSize]
              );
              cls.DOMElementHelper.toggleClass(this._previousScroller, "overflown-previous", scroll > 0);
            }
          }.bind(this)
        );
      },

      /**
       * Display or not the scrollers
       * @param display
       */
      showScroller: function (display) {
        cls.DOMElementHelper.toggleClasses(this._previousScroller, !display, "vanished");
        cls.DOMElementHelper.toggleClasses(this._nextScroller, !display, "vanished");
      },

      /**
       * Scroll the title bar to see the given element
       * @param {classes.PageWidget} element
       */
      scrollTo: function (element) {
        if (this._scrollToId) {
          window.cancelAnimationFrame(this._scrollToId);
        }
        this._scrollToId = window.requestAnimationFrame(
          function () {
            this._scrollToId = 0;
            if (element) {
              const scroll = this._tabsTitlesHost[this._scrollPos];
              const titleLeft = element[this._offsetPos],
                titleWidth = element[this._offsetSize],
                hostWidth = this._tabsTitlesHost[this._offsetSize],
                deltaLeft = titleLeft - scroll;
              if (deltaLeft < 0 || deltaLeft + titleWidth > hostWidth) {
                this._tabsTitlesHost[this._scrollPos] = titleLeft;
              }
            }
            this.refreshScrollers();
          }.bind(this)
        );
      },

      /**
       *
       * @param position
       * @private
       */
      _updateOffset: function (position) {
        switch (position) {
          case "top":
          case "bottom":
            this._offsetPos = "offsetLeft";
            this._offsetSize = "offsetWidth";
            this._scrollPos = "scrollLeft";
            this._scrollStep = 6;
            break;
          case "left":
          case "right":
            this._offsetPos = "offsetTop";
            this._offsetSize = "offsetHeight";
            this._scrollPos = "scrollTop";
            this._scrollStep = 2;
            break;
        }
      },

      /**
       * Set the tabs position
       * @param {string} tag - tag of the item
       * @param {string} position - could be top, right, bottom or left
       * @publicdoc
       */
      updatePosition: function (tag, position) {
        this._position = position;
        if (this._tabsHost) {
          this._tabsHost.setAttribute(tag, position);
        }
        if (this._tabsTitlesBar) {
          this._tabsTitlesBar.setAttribute(tag, position);
        }
        if (this._tabsTitlesHost) {
          this._tabsTitlesHost.setAttribute(tag, position);
        }
        if (this._tabsTitlesElement) {
          this._tabsTitlesElement.setAttribute(tag, position);
        }
        if (this._previousScroller) {
          this._previousScroller.setAttribute(tag, position);
        }
        if (this._nextScroller) {
          this._nextScroller.setAttribute(tag, position);
        }

        this._updateOffset(position);
      },

      /**
         Touch / Mobile specific methods
         **/

      /**
       * Handler when a finger touches the screen
       * @param evt
       * @private
       */
      _startTouchScroll: function (evt) {
        const styleAttr = ["top", "bottom"].indexOf(this._position) >= 0 ? "scrollLeft" : "scrollTop";
        this._scrollTouching = true;
        this._scrollTouchingPos = evt.changedTouches[0];
        this._scrollerPosition = this._tabsTitlesHost[styleAttr];
        this._nextScroller.classList.add("overflown-next");
        this._previousScroller.classList.add("overflown-previous");
        this._preventContainerScrolling(true);
      },

      /**
       * Handler when a finger stop touching the screen
       * @private
       */
      _endTouchScroll: function () {
        this._scrollTouching = false;
        this._scrollTouchingPos = null;
        this._preventContainerScrolling(false);
        this.refreshScrollers();
      },

      /**
       * Moves the scroller as the finger moves on touchscreen
       * @param evt
       * @private
       */
      _touchMove: function (evt) {
        const styleAttr = ["top", "bottom"].indexOf(this._position) >= 0 ? "scrollLeft" : "scrollTop";
        const rectAttr = ["top", "bottom"].indexOf(this._position) >= 0 ? "clientX" : "clientY";
        if (this._scrollTouching) {
          // move to current tabs position minus the drift from touch start to touch current pos
          this._tabsTitlesHost[styleAttr] = this._scrollerPosition - (evt.changedTouches[0][rectAttr] - this._scrollTouchingPos[rectAttr]);
        }
      },

      /**
       * Prevent the container to scroll while doing touch to scroll the tab-titles
       * @param {Boolean} prevent - true to prevent it, false otherwise
       * @private
       */
      _preventContainerScrolling: function (prevent) {
        const form = this._widget.getFormWidget();
        if (form) {
          cls.DOMElementHelper.toggleClass(form.getContainerElement(), "prevent-touch-scroll", prevent);
        }
      },

      /**
       * Gets the tabs host element
       * @returns {Element} the element
       */
      getTabsHost: function () {
        return this._tabsHost;
      }
    };
  });
});
